export default function ProgressBar({ current, total }) {
  const percent = Math.round((current / total) * 100);
  return (
    <div className="w-full bg-gray-200 h-4 rounded mb-4">
      <div
        className="h-full bg-blue-500 rounded"
        style={{ width: percent + '%' }}
      ></div>
    </div>
  );
}
